export const themes = [
  {//landing default color, all white
    //theme 0
    fontFamily: "",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: false,
    headerLogoPosition: "center",
    primaryColor: "white",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#333333",
    menuItemPriceColor: "#8a5700",
    checkInPrimaryColor: "white",
    secondaryColor: "white",
    selectedColor: "white",
    //menu header color
    menuHeaderColor: "white",
    menuTitleColor: "white",
    optionHeaderBackgroundColor: "white",
    optionHeaderColor: "white",
    optionBorderColor: "white",
    optionPriceColor: "white",
    backgroundColor: "white",
    cartColor1: "white", //check out background
    cartColor2: "white",
    cartFont: "white",
    borderColor: "white",
    topBarSubBg: "wghite",
    fontPrimary: "white",
    fontSecondary: "white",
    fontShadow: "white",
    fontPrice: "white",
    fontAlert: "red",
    selectedCategory: "white",
    unselectedCategory: "white",
    fontItemPrice: 'white',
    headerColor: "white",
    itemPrice: "white",
    selectedCatBg: "white",
    selectedSubCatBg: "white"
  },
  { //Black Theme
    //theme 0
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "black",
    primaryColor: "black",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#1e1e1e",
    menuItemPriceColor: "#8a5700",
    secondaryColor: "#1e1e1e", //side bar background
    checkInPrimaryColor: "#fff",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#1e1e1e", //menu top background
    menuTitleColor: "black",

    optionHeaderBackgroundColor: "#1e1e1e",  //"#455a64",
    optionHeaderColor: "#f8dd78", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "white",
    cartColor1: "#f8dd78",
    backgroundColor: "#fff",

    cartColor1: "#f3962b",
    cartColor2: "#3fbd11",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "black", //container detail font color
    fontSecondary: "#f8dd78", //menu item color
    headerColor: "#f8dd78",
    fontShadow: "black",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "white",//category selected color
    unselectedCategory: "#f8dd78", //category color
    fontItemPrice: '#f8dd78',
    checkOutArrow: "#f8dd78", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#f3962b",
    selectedSubCatBg: "#f3962b",
    modalButton: "white"
  },
  { //theme red for restaurant Ippudo
    //theme 1
    fontFamily: "\'Roboto\'",
    sidebarWidth: 105,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,
    headerLogoPosition: "center",
    topBarSubBg: "#CF000d",
    primaryColor: "#Cf000d",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#262626",
    menuItemPriceColor: "#262626",
    secondaryColor: "black",
    checkInPrimaryColor: "#fff",
    selectedColor: "#Cf000d",
    menuHeaderColor: "#CF000D",
    menuTitleColor: "black",
    optionHeaderBackgroundColor: "white",
    optionHeaderColor: "black",
    optionBorderColor: "#ddd",
    optionPriceColor: "#CF000D",
    backgroundColor: "#fff",
    cartColor1: "#CF000D",
    cartColor2: "#004D4A",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "black",
    fontSecondary: 'black',
    headerColor: "black",
    fontShadow: "black",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#Cf000d",
    unselectedCategory: "white",
    fontItemPrice: "#Cf000d",
    checkOutArrow: "white", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#CF000D",
    selectedSubCatBg: "black",
    modalButton: "white"
  },
  { //monica theme, Purple
    //theme 2
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: false,
    headerLogoPosition: "center",
    topBarSubBg: "#6A5ACD",
    primaryColor: "#6A5ACD",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#6a5acd",
    menuItemPriceColor: "#806000",
    secondaryColor: "white",
    // checkInPrimaryColor: "#1e1e1e",
    selectedColor: "#Cf000d",
    fontPrimary: "black",
    fontSecondary: "black",
    headerColor: "black",
    fontPrice: "#6A5ACD",
    //menu header color
    menuHeaderColor: "#b6b6ff",
    menuTitleColor: "white",

    optionHeaderBackgroundColor: "white",
    optionHeaderColor: "white",
    optionBorderColor: "#ddd",
    optionPriceColor: "white",

    backgroundColor: "white",
    cartFont: "white",

    borderColor: "#ddd",
    cartColor1: "#6A5ACD",
    cartColor2: "#004D4A",
    fontShadow: "white",
    fontAlert: "red",
    selectedCategory: "#6A5ACD",
    unselectedCategory: "b6b6ff",
    fontItemPrice: 'white',
    checkOutArrow: "#6A5ACD", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#6A5ACD",
    selectedSubCatBg: "#004D4A"
  },
  { //Pink Theme
    //theme 3
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#e91e63",
    primaryColor: "#e91e63",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#c2185b",
    menuItemPriceColor: "#006b65",
    checkoutTextColor: "#ffffff",
    secondaryColor: "#e91e63",
    checkInPrimaryColor: "#fff",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#f9878e",
    menuTitleColor: "black",

    optionHeaderBackgroundColor: "#e91e63",  //"",
    optionHeaderColor: "white", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "white",

    backgroundColor: "#fff",

    cartColor1: "#673ab7",
    cartColor2: "#f44336",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "black",
    fontSecondary: "white",
    headerColor: "white",
    fontShadow: "black",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#f8dd78",
    unselectedCategory: "white",
    fontItemPrice: 'white',
    checkOutArrow: "white", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#673ab7",
    selectedSubCatBg: "#673ab7"
  },
  { //blue theme 1
    //theme 4
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#023047",
    //main color
    primaryColor: "#023047",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#023047",
    menuItemPriceColor: "#a34f00",
    secondaryColor: "#023047",
    checkInPrimaryColor: "#fff",

    //item option selected color
    selectedColor: "#Cf000d",
    //menu header color
    menuHeaderColor: "#023047",
    menuTitleColor: "black",

    //item option header
    optionHeaderBackgroundColor: "#023047",  //"#455a64",
    optionHeaderColor: "white", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "white",

    //menu background color
    backgroundColor: "white",
    //checkout button
    cartColor1: "#fb8500",
    cartColor2: "#ffb703",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "#023047",
    fontSecondary: "white",
    headerColor: "white",
    fontShadow: "black",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#f8dd78",
    unselectedCategory: "white",
    fontItemPrice: 'white',
    checkOutArrow: "white", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#fb8500",
    selectedSubCatBg: "#fb8500"
  },
  { //blue theme 2
    //theme 5
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#003459",
    //main color
    primaryColor: "#003459",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#003459",
    menuItemPriceColor: "#a34f00",
    secondaryColor: "#003459",
    checkInPrimaryColor: "#ffffff",

    //item option selected color
    selectedColor: "#Cf000d",
    //menu header color
    menuHeaderColor: "#003459",
    menuTitleColor: "black",

    //item option header
    optionHeaderBackgroundColor: "#003459",  //"#455a64",
    optionHeaderColor: "white", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "white",

    //menu background color
    backgroundColor: "white",
    //checkout button
    cartColor1: "#007ea7",
    cartColor2: "#007ea7",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "black",
    fontSecondary: "white",
    headerColor: "white",
    fontShadow: "black",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#f8dd78",
    unselectedCategory: "white",
    fontItemPrice: 'white',
    checkOutArrow: "white", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#007ea7",
    selectedSubCatBg: "#007ea7"
  },
  {//monica new Theme, yellow theme
    //theme 6
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,
    headerLogoPosition: "center",
    topBarSubBg: "#EAB23B",
    primaryColor: "#EAB23B",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#856000",
    menuItemPriceColor: "#005f78",
    secondaryColor: "#fad17d",
    selectedColor: "#Cf000d",
    checkInPrimaryColor: "#303133",
    fontPrimary: "#EAB23B",
    fontSecondary: "#303133",
    headerColor: "#303133",
    fontPrice: "#cf000d",
    cartColor1: "#007ea7",
    cartColor2: "#007ea7",
    backgroundColor: "#fff",
    borderColor: "#ddd",
    cartFont: "white",
    checkOutArrow: "#f8dd78", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#007ea7",
    selectedSubCatBg: "#007ea7"
  },
  {//green theme
    //theme 7
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,
    headerLogoPosition: "center",
    menuHeaderColor: "#F5F5F5",
    topBarSubBg: "#90A58A",
    primaryColor: "#90A58A",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#506b49",
    menuItemPriceColor: "#974727",
    secondaryColor: "#90A58A", //category backgroun dcolor
    selectedColor: "#Cf000d",

    fontPrimary: "#90A58A",
    fontSecondary: "#303133",
    headerColor: "#303133",
    fontPrice: "#cf000d",

    backgroundColor: "#fff",
    borderColor: "#ddd",
    cartFont: "white",
    checkOutArrow: "#f8dd78", //checkOut Arrow Color

    selectedCategory: "white",//category selected color
    unselectedCategory: "#fff9c4", //category color

    cartColor1: "#558b2f", //check out background
    cartColor2: "#ffbb2a",
    itemPrice: "white",
    selectedCatBg: "#558b2f",
    selectedSubCatBg: "#558b2f"
  },
  {//green theme 2
    //theme 8
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,
    headerLogoPosition: "center",
    menuHeaderColor: "#F5F5F5",
    optionHeaderBackgroundColor: "#90A58A",
    primaryColor: "#90A58A",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#506b49",
    menuItemPriceColor: "#974727",
    secondaryColor: "#90A58A", //category backgroun dcolor
    selectedColor: "#Cf000d",
    topBarSubBg: "#90A58A",
    fontPrimary: "#90A58A",
    fontSecondary: "#f8dd78",
    headerColor: "black",
    fontPrice: "#cf000d",

    backgroundColor: "#fff",
    borderColor: "#ddd",
    cartFont: "white",
    checkOutArrow: "#f8dd78", //checkOut Arrow Color

    selectedCategory: "white",//category selected color
    unselectedCategory: "#fff9c4", //category color

    cartColor1: "#558b2f", //check out background
    cartColor2: "#ffbb2a",
    itemPrice: "white",
    selectedCatBg: "#558b2f",
    selectedSubCatBg: "#558b2f"
  },
  { //Black Theme 2
    //theme 9
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#424242",
    primaryColor: "#424242",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#424242",
    menuItemPriceColor: "#986000",
    secondaryColor: "#424242", //side bar background
    checkInPrimaryColor: "#fff",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#424242", //menu top background
    menuTitleColor: "#424242",

    optionHeaderBackgroundColor: "#424242",  //"#455a64",
    optionHeaderColor: "white", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "white",

    backgroundColor: "#fff",

    cartColor1: "#f3962b",
    cartColor2: "#3fbd11",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "#424242", //container detail font color
    fontSecondary: "white", //menu item color
    headerColor: "white",
    fontShadow: "#424242",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#f8dd78",//category selected color
    unselectedCategory: "white", //category color
    fontItemPrice: 'white',
    checkOutArrow: "white", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#f3962b",
    selectedSubCatBg: "#f3962b"
  },
  { //Sky Blue Theme
    //theme 10
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#4a94bb",
    primaryColor: "#4a94bb",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#286a8e",
    menuItemPriceColor: "#a34f00",
    checkoutTextColor: "#ffffff",
    secondaryColor: "#4a94bb", //side bar background
    // checkInPrimaryColor: "#1e1e1e",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#4a94bb", //menu top background
    menuTitleColor: "#4a94bb",

    optionHeaderBackgroundColor: "#4a94bb",  //"#455a64",
    optionHeaderColor: "white", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "white",

    backgroundColor: "#fff",

    cartColor1: "#f3962b",
    cartColor2: "#3fbd11",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "#4a94bb", //container detail font color
    fontSecondary: "white", //menu item color
    headerColor: "white",
    fontShadow: "#4a94bb",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#f8dd78",//category selected color
    unselectedCategory: "white", //category color
    fontItemPrice: 'white',
    checkOutArrow: "white", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#f3962b",
    selectedSubCatBg: "#f3962b"
  },
  { //Dark Green Theme
    //theme 11
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#0A433A",
    primaryColor: "#0A433A",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#0a433a",
    menuItemPriceColor: "#986000",
    secondaryColor: "#0A433A", //side bar background
    checkInPrimaryColor: "#fff",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#0A433A", //menu top background
    menuTitleColor: "#0A433A",

    optionHeaderBackgroundColor: "#0A433A",  //"#455a64",
    optionHeaderColor: "#FFD57F", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "#FFD57F",

    backgroundColor: "#fff",

    cartColor1: "#f3962b",
    cartColor2: "#3fbd11",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "#0A433A", //container detail font color
    fontSecondary: "#FFD57F", //menu item color
    headerColor: "#FFD57F",
    fontShadow: "#0A433A",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#f8dd78",//category selected color
    unselectedCategory: "#FFD57F", //category color
    fontItemPrice: '#FFD57F',
    checkOutArrow: "#FFD57F", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#f3962b",
    selectedSubCatBg: "#f3962b"
  },
  { //Biege Theme
    //theme 12
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#292218",
    primaryColor: "#af231c",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#af231c",
    menuItemPriceColor: "#00645f",
    secondaryColor: "#292218", //side bar background
    // checkInPrimaryColor: "#1e1e1e",

    selectedColor: "#af231c",

    menuHeaderColor: "#292218", //menu top background
    menuTitleColor: "#292218",

    optionHeaderBackgroundColor: "#af231c",  //"#455a64",
    optionHeaderColor: "#af231c", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "#FFD57F",

    backgroundColor: "#f3e9df",

    cartColor1: "#af231c",
    cartColor2: "#af231c",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "#292218", //container detail font color
    fontSecondary: "#FFD57F", //menu item color
    headerColor: "#FFD57F",
    fontShadow: "#292218",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#f8dd78",//category selected color
    unselectedCategory: "#FFD57F", //category color
    fontItemPrice: '#FFD57F',
    checkOutArrow: "#FFD57F", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#af231c",
    selectedSubCatBg: "#af231c",

  },
  { //Jungle Theme
    //theme 13
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#0d261c",
    primaryColor: "#0d261c",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#0d261c",
    menuItemPriceColor: "#895200",
    secondaryColor: "#292218", //side bar background
    checkInPrimaryColor: "white",
    checkInSecondaryColor: "#CEF580",
    selectedColor: "#0d261c",

    menuHeaderColor: "#0d261c", //menu top background
    menuTitleColor: "#0d261c",

    optionHeaderBackgroundColor: "#0d261c",  //"#455a64",
    optionHeaderColor: "#0d261c", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "#CEF580",

    backgroundColor: "#f3e9df",

    cartColor1: "#0d261c",
    cartColor2: "#0d261c",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "#292218", //container detail font color
    fontSecondary: "#CEF580", //menu item color
    headerColor: "#CEF580",
    fontShadow: "#292218",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#8dc51c",//category selected color
    unselectedCategory: "#CEF580", //category color
    fontItemPrice: '#CEF580',
    checkOutArrow: "#CEF580", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#CEF580",
    selectedSubCatBg: "#CEF580",
    selectedCatColor: "#0d261c",
    checkInbackgroundColor: "#0d261c",
    catBackgroundColor: "#0d261c",
    checkInEnterColor: "#0d261c"
  },
  { //Black Theme
    //theme 14
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "black",
    primaryColor: "black",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#1e1e1e",
    menuItemPriceColor: "#2b57ad",
    secondaryColor: "#1e1e1e", //side bar background
    checkInPrimaryColor: "#fff",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#1e1e1e", //menu top background
    menuTitleColor: "black",

    optionHeaderBackgroundColor: "#2B57AD",  //"#455a64",
    optionHeaderColor: "#f8dd78", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "white",

    backgroundColor: "#fff",

    cartColor1: "#2B57AD",
    cartColor2: "#2B57AD",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "black", //container detail font color
    fontSecondary: "#f8dd78", //menu item color
    headerColor: "#f8dd78",
    fontShadow: "black",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "white",//category selected color
    unselectedCategory: "#f8dd78", //category color
    fontItemPrice: '#f8dd78',
    checkOutArrow: "#f8dd78", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#2B57AD",
    selectedSubCatBg: "#2B57AD"
  },
  { //Black Theme 4
    //theme 15
    fontFamily: "\'Copperplate\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "black",
    primaryColor: "black",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#1e1e1e",
    menuItemPriceColor: "#8a5700",
    secondaryColor: "#1e1e1e", //side bar background
    checkInPrimaryColor: "#fff",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#1e1e1e", //menu top background
    menuTitleColor: "black",

    optionHeaderBackgroundColor: "#1e1e1e",  //"#455a64",
    optionHeaderColor: "white", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "white",

    backgroundColor: "#fff",

    cartColor1: "#f3962b",
    cartColor2: "#3fbd11",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "black", //container detail font color
    fontSecondary: "white", //menu item color
    headerColor: "white",
    fontShadow: "black",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "white",//category selected color
    unselectedCategory: "white", //category color
    fontItemPrice: '#f8dd78',
    checkOutArrow: "#f8dd78", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#f3962b",
    selectedSubCatBg: "#f3962b"
  },
  { //Green Theme 3
    //theme 16
    //467941
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#467941",
    primaryColor: "#467941",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#467941",
    menuItemPriceColor: "#974727",
    secondaryColor: "#467941", //side bar background
    checkInPrimaryColor: "#ffffff",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#467941", //menu top background
    menuTitleColor: "#467941",

    optionHeaderBackgroundColor: "#467941",  //"#455a64",
    optionHeaderColor: "#ffffff", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "#ffffff",

    backgroundColor: "#fff",

    cartColor1: "#f3962b",
    cartColor2: "#3fbd11",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "#467941", //container detail font color
    fontSecondary: "#ffffff", //menu item color
    headerColor: "#ffffff",
    fontShadow: "#467941",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#ffffff",//category selected color
    unselectedCategory: "#ffffff", //category color
    fontItemPrice: '#ffffff',
    checkOutArrow: "#ffffff", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#f3962b",
    selectedSubCatBg: "#f3962b"
  },
  { //Purple Theme 2
    //theme 17
    //467941
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#462868",
    primaryColor: "#462868",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#462868",
    menuItemPriceColor: "#876000",
    secondaryColor: "#462868", //side bar background
    checkInPrimaryColor: "#fff",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#EECCC9", //menu top background
    menuTitleColor: "#467941",

    optionHeaderBackgroundColor: "#462868",  //"#455a64",
    optionHeaderColor: "#ffffff", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "#ffffff",

    backgroundColor: "#fff",
    modalButton: "#D1C4DC",
    cartColor1: "#D1C4DC",
    cartColor2: "#D1C4DC",
    cartFont: "#462868",

    borderColor: "#ddd",

    fontPrimary: "#462868", //container detail font color
    fontSecondary: "#ffffff", //menu item color
    headerColor: "#462868",
    fontShadow: "#462868",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#ffffff",//category selected color
    unselectedCategory: "#D1C4DC", //category color
    fontItemPrice: '#ffffff',
    checkOutArrow: "#ffffff", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#f3962b",
    selectedSubCatBg: "#f3962b"
  },
  { //Amber Theme 2
    //theme 18
    //467941
    fontFamily: "\'RobotoCondensed\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#bb7458",
    primaryColor: "#bb7458",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#98543c",
    menuItemPriceColor: "#006b70",
    checkoutTextColor: "#ffffff",
    secondaryColor: "#bb7458", //side bar background
    checkInPrimaryColor: "#f4b184",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#f4b184", //menu top background
    menuTitleColor: "#467941",

    optionHeaderBackgroundColor: "#bb7458",
    optionHeaderColor: "#ffffff", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "#ffffff",

    backgroundColor: "#fff",
    modalButton: "#f4b184",
    cartColor1: "#bb7458",
    cartColor2: "#bb7458",
    cartFont: "white",

    borderColor: "#ddd",

    fontPrimary: "#bb7458", //container detail font color
    fontSecondary: "#ffffff", //menu item color
    headerColor: "#bb7458",
    fontShadow: "#bb7458",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#ffffff",//category selected color
    unselectedCategory: "#ffffff", //category color
    fontItemPrice: '#ffffff',
    checkOutArrow: "#ffffff", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#f3962b",
    selectedSubCatBg: "#f3962b"
  },
  { //Red Theme 3
    //theme 19
    //467941
    fontFamily: "\'Lora\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,

    headerLogoPosition: "center",
    topBarSubBg: "#692116",
    primaryColor: "#692116",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#692116",
    menuItemPriceColor: "#246047",
    secondaryColor: "#692116", //side bar background
    checkInPrimaryColor: "#fff",

    selectedColor: "#Cf000d",

    menuHeaderColor: "#692116", //menu top background
    menuTitleColor: "#e7e0c5",

    optionHeaderBackgroundColor: "#1F3920",
    optionHeaderColor: "#ffffff", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "#ffffff",
    barUnselectedBg: "#f4b184",
    backgroundColor: "#E7E0C5",
    modalButton: "#f4b184",
    cartColor1: "#80BAE8",
    cartColor2: "#80BAE8",
    cartFont: "#692116",
    selectedCatColor: "#E7E0C5",
    topBarText: "#E7E0C5",
    borderColor: "#692116",

    fontPrimary: "#692116", //container detail font color
    fontSecondary: "#E7E0C5", //menu item color
    headerColor: "#E7E0C5",
    fontShadow: "#bb7458",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#E7E0C5",//category selected color
    unselectedCategory: "#E7E0C5", //category color
    fontItemPrice: '#ffffff',
    checkOutArrow: "#ffffff", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#FF6702",
    selectedSubCatBg: "#FF6702",
    descriptionColor: "#692116"
  },
  { //PINK Theme 2
    //theme 20
    //467941
    fontFamily: "\'Lora\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,
    checkInPrimaryColor: "#fff",
    headerLogoPosition: "center",
    topBarSubBg: "#671D38",
    primaryColor: "#671D38",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#671d38",
    menuItemPriceColor: "#006b65",
    secondaryColor: "#671D38", //side bar background
    selectedColor: "#Cf000d",
    menuHeaderColor: "#671D38", //menu top background
    menuTitleColor: "#e7e0c5",
    optionHeaderBackgroundColor: "#671d38",
    optionHeaderColor: "#ffffff", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "#ffffff",
    barUnselectedBg: "#f4b184",
    backgroundColor: "#fff",
    modalButton: "#f4b184",
    cartColor1: "#671D38",
    cartColor2: "#671D38",
    cartFont: "#FFF8D8",
    selectedCatColor: "#671D38",
    topBarText: "#E7E0C5",
    borderColor: "#671D38",
    checkInEnterColor: "#FFF8D8",
    fontPrimary: "#671D38", //container detail font color
    fontSecondary: "#E7E0C5", //menu item color
    headerColor: "#E7E0C5",
    fontShadow: "#bb7458",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#E8CFCF",//category selected color
    unselectedCategory: "#FFF8D8", //category color
    fontItemPrice: '#ffffff',
    checkOutArrow: "#ffffff", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#FFF8D8",
    selectedSubCatBg: "#FFF8D8",
    descriptionColor: "#000000"
  },
  { //Red Color Theme 2
    //theme 20
    //467941
    fontFamily: "\'roboto\'",
    sidebarWidth: 100,
    headerHeight: 40,
    maxPax: 30,
    sidebarFixedSize: true,
    checkInPrimaryColor: "#fff",
    headerLogoPosition: "center",
    topBarSubBg: "#801517",
    primaryColor: "#801517",
    // Menu card colors: theme-toned names with a harmonious price accent.
    menuItemNameColor: "#801517",
    menuItemPriceColor: "#00645f",
    secondaryColor: "#801517", //side bar background
    selectedColor: "#801517",
    menuHeaderColor: "#801517", //menu top background
    menuTitleColor: "#801517",
    optionHeaderBackgroundColor: "#801517",
    optionHeaderColor: "#ffffff", //"#f8dd78",
    optionBorderColor: "#ddd",
    optionPriceColor: "#ffffff",
    barUnselectedBg: "#fff",
    backgroundColor: "#fff",
    modalButton: "#fff",
    cartColor1: "#801517",
    cartColor2: "#801517",
    cartFont: "#fff",
    selectedCatColor: "#ffffff",
    topBarText: "#fff",
    borderColor: "#801517",
    checkInEnterColor: "#fff",
    fontPrimary: "#801517", //container detail font color
    fontSecondary: "#fff", //menu item color
    headerColor: "#fff",
    fontShadow: "#fff",
    fontPrice: "#cf000d",
    fontAlert: "red",
    selectedCategory: "#f8dd78", //category selected color
    unselectedCategory: "#fff", //category color
    fontItemPrice: '#ffffff',
    checkOutArrow: "#ffffff", //checkOut Arrow Color
    itemPrice: "white",
    selectedCatBg: "#801517",
    selectedSubCatBg: "#f8dd78",
    descriptionColor: "#000000"
  },
];
